import { Image } from '@/components/base';
import { toClassNames } from '@/utils';

export enum AvatarDisplayType {
  Default = 'Default',
  Locked = 'Locked',
  Selected = 'Selected',
}

interface AvatarDisplayProps {
  variant: AvatarDisplayType;
  backgroundImageUrl?: string;
  avatarImageUrl?: string;
  decorationImageUrl?: string;
}

export const AvatarDisplay = ({
  variant,
  backgroundImageUrl,
  avatarImageUrl,
  decorationImageUrl,
}: AvatarDisplayProps) => {
  return (
    <div
      className={toClassNames(
        `relative h-full w-full overflow-hidden rounded-full bg-revamp-blue-100 bg-cover bg-center`,
        variant === AvatarDisplayType.Selected && 'ring-[5px] ring-revamp-cobalt-400'
      )}
      style={{ backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : undefined }}
    >
      {avatarImageUrl && (
        <div className="absolute left-0 top-0 flex h-full w-full items-end justify-center">
          <Image src={avatarImageUrl} alt="avatar-example" className="h-full" />
        </div>
      )}
      {decorationImageUrl && (
        <div className="absolute left-0 top-0 flex h-full w-full items-end justify-center">
          <Image src={decorationImageUrl} alt="avatar-frame" className="h-full" />
        </div>
      )}
      {variant === AvatarDisplayType.Locked && (
        <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center bg-black opacity-50">
          <Image src="/assets/images/avatar_locked.svg" alt="avatar-locked" className="w-[50%]" />
        </div>
      )}
    </div>
  );
};
